import React, { createContext, useContext } from "react";
import { message } from "antd";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";

const NotificationContext = createContext();

export const useNotification = () => useContext(NotificationContext);

const getMessageStyle = (type) => {
  switch (type) {
    case "success":
      return {
        backgroundColor: "hsl(var(--success-bg))",
        borderColor: "hsl(var(--success-border))",
        icon: (
          <CheckCircleOutlined style={{ color: "hsl(var(--success-icon))" }} />
        ),
        textColor: "hsl(var(--success-text))",
      };
    case "error":
      return {
        backgroundColor: "hsl(var(--error-bg))",
        borderColor: "hsl(var(--error-border))",
        icon: (
          <CloseCircleOutlined style={{ color: "hsl(var(--error-icon))" }} />
        ),
        textColor: "hsl(var(--error-text))",
      };
    case "warning":
      return {
        backgroundColor: "hsl(var(--warning-bg))",
        borderColor: "hsl(var(--warning-border))",
        icon: (
          <ExclamationCircleOutlined
            style={{ color: "hsl(var(--warning-icon))" }}
          />
        ),
        textColor: "hsl(var(--warning-text))",
      };
    default: // info
      return {
        backgroundColor: "hsl(var(--info-bg))",
        borderColor: "hsl(var(--info-border))",
        icon: <InfoCircleOutlined style={{ color: "hsl(var(--info-icon))" }} />,
        textColor: "hsl(var(--info-text))",
      };
  }
};

const NotificationProvider = ({ children }) => {
  // Normal Ant Design Message
  const showMessage = (type, content, duration = 3, key = "normal") => {
    const style = getMessageStyle(type);

    message.open({
      key,
      type,
      content: content,
      duration, // Auto-closes after set time
    });
  };

  // Persistent Message (Requires Manual Close)
  const showPersistentMessage = (type, content, key = "persistentMessage") => {
    const style = getMessageStyle(type);

    message.open({
      key,
      type,
      content: (
        <div>
          {content}
          <button
            style={{
              marginLeft: "10px",
              padding: "2px 5px",
              border: "none",
              backgroundColor: "hsl(var(--primary))",
              color: "hsl(var(--primary-foreground))",
              cursor: "pointer",
              borderRadius: "3px",
            }}
            onClick={() => message.destroy(key)}
          >
            Close
          </button>
        </div>
      ),
      duration: 0,
    });
  };

  return (
    <NotificationContext.Provider
      value={{ showMessage, showPersistentMessage }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

export default NotificationProvider;
